<template>
    <div>
        <div class="mb10">
            <span class="font14px text-bold pr20 pointer" @click="toListPage">
                <i class="el-icon-back"></i>Return</span>|
            <span class="font12px text-color-gray pl20">Task：</span>
            <span class="pr20">{{data.task_name||'--'}}</span>
            <el-button v-if="pageFuncNames.includes('daily_task_feature')" type="primary" size="mini" @click="editTask">Edit</el-button>
        </div>
        <div class="filter-bar mb10">
            <el-form :inline="true" @submit.native.prevent="submitSearch">
                <el-form-item label="">
                    <el-input v-model="tempQuery.daily_file_name" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="Please enter file name keywords to search" style="width: 260px;">
                        <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-select
                        class="select-tags-width"
                        v-model="tempQuery.account_id"
                        placeholder="Account Filter, Supports Name or ID Search"
                        multiple
                        clearable
                        filterable
                        remote
                        reserve-keyword
                        :remote-method="(query) => remoteMethod(query, 'creator')"
                        :loading="searchAccountLoading"
                        style="width: 220px">
                        <el-option v-for="item in filterAccountOptions" :key="item.id"
                                   :label="item.name + '(' + item.id + ')'" :value="item.id">
                            <span style="float: left">{{ item.name }}（{{ item.id }}）</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select
                        class="select-tags-width"
                        v-model="tempQuery.subitem_id"
                        placeholder="Product Filter, Supports Name, ID, or Package Name Search"
                        style="width: 220px"
                        multiple
                        collapse-tags
                        clearable
                        filterable
                        remote
                        reserve-keyword
                        :remote-method="(query) => remoteMethod(query, 'app')"
                        :loading="searchAppLoading"
                    >
                        <el-option v-for="item in filterAppOptions" :key="item.subitem_id"
                                   :label="item.subproject_name + '(' + item.subproject_id + ')'" :value="item.subitem_id">
                            <span style="float: left">{{ item.subproject_name }}（{{ item.subproject_id }}）</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="tempQuery.template_id" placeholder="Template Filter" style="width: 175px"
                               class="select-tags-width" multiple collapse-tags clearable filterable>
                        <el-option :label="option.template_name" :value="option.template_id"
                                   v-for="option in filterTempOptions" :key="option.template_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;">Filter</el-button>
                    <el-button size="mini" @click="resetForm">Reset Filters</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-list">
            <el-table
                ref="dataTable"
                :data="dataList"
                v-loading="dataLoading"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                stripe
                style="width: 100%;">
                <el-table-column
                    type="index"
                    label="Serial Number"
                    align="center"
                    width="120">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="daily_file_name"
                    label="File Name"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="Switch"
                    align="center"
                    min-width="100">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="top">
                            <span class="pointer">Switch <i class="el-icon-question"></i></span>
                            <div slot="content" style="max-width: 300px;line-height: 20px;">
                                <p>After closing, this file will not be generated during the process and will not be included in the send.</p>
                            </div>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-switch
                            v-if="pageFuncNames.includes('daily_task_feature')"
                            class="mini-switch"
                            :value="scope.row.status"
                            :disabled="scope.row.statusLoading"
                            @change="changeTaskStatus(scope.row,$event)"
                            active-value="1"
                            inactive-value="0"
                        ></el-switch>
                        <span v-else>{{scope.row.status=='1'?'On':scope.row.status=='0'?'Off':'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="Media"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="account"
                    label="Account & Product"
                    min-width="150">
                    <template slot-scope="scope">
                        <el-popover width="460" trigger="hover">
                            <span slot="reference" class="text-color-primary pointer">
                                <span v-if="scope.row.company.length>0">Account（{{scope.row.company.length}}）</span>
                                <span v-if="scope.row.app.length>0"> Product（{{scope.row.app.length}}）</span>
                                <span v-if="scope.row.customer.length>0"> Client（{{scope.row.customer.length}}）</span>
                            </span>
                            <div style="max-height: 360px;overflow-y: auto;">
                                <div class="company-list" v-if="scope.row.company.length>0">
                                    <h3>Account</h3>
                                    <p v-for="item in scope.row.company||[]" :key="item.account_id" class="pl20 ellipsis" :title="item.account_name+'-'+(scope.row.plat_name=='vivo'?item.user_name:item.account_id)">{{item.account_name}}（{{scope.row.plat_name=='vivo'?item.user_name:item.account_id}}）</p>
                                </div>
                                <div class="app-list" v-if="scope.row.app.length>0">
                                    <h3>Product</h3>
                                    <p v-for="item in scope.row.app||[]" :key="item.subitem_id" class="pl20 ellipsis" :title="item.subproject_name+'-'+item.subproject_id+(scope.row.plat_id=='3'?('（'+item.subproject_content+'）'):'')">{{item.subproject_name}}（{{item.subproject_id}}）<span v-if="scope.row.plat_id=='3'">（{{item.subproject_content}}）</span></p>
                                </div>
                                <div class="app-list" v-if="scope.row.customer.length>0">
                                    <h3>Client</h3>
                                    <p v-for="item in scope.row.customer||[]" :key="item.company_name" class="pl20 ellipsis" :title="item.company_name">{{item.company_name}}</p>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="template_name"
                    show-overflow-tooltip
                    label="Template"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="generate_status"
                    label="Generation Status"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.generate_status=='0'" class="text-color-failed" :title="scope.row.status_text">Not Started</span>
                        <span v-else-if="scope.row.generate_status=='1'" class="text-color-warn" :title="scope.row.status_text">Data extraction is in progress</span>
                        <span v-else-if="scope.row.generate_status=='2'" class="text-color-warn" :title="scope.row.status_text">Data is not out, being generated</span>
                        <span v-else-if="scope.row.generate_status=='3'" class="text-color-warn" :title="scope.row.status_text">Generating</span>
                        <span v-else-if="scope.row.generate_status=='4'" class=" text-color-success" :title="scope.row.status_text">Generation successful</span>
                        <span v-else-if="scope.row.generate_status=='5'" class="text-color-success" :title="scope.row.status_text">Data not out, generation successful</span>
                        <template v-else-if="scope.row.generate_status=='6'">
                            <el-tooltip class="item" effect="dark" placement="top">
                                <span class="mr4 text-color-failed pointer">Generation failed
                                    <i class="el-icon-warning-outline text-color-failed"></i>
                                </span>
                                <div slot="content" style="max-width: 500px;max-height: 300px;overflow-y: auto;" class="break-word">
                                    <div v-if="scope.row.generate_error" v-html="scope.row.generate_error"></div>
                                    <span v-else>Generation failed</span>
                                </div>
                            </el-tooltip>
                        </template>
                        <span v-else-if="scope.row.generate_status=='7'" class="text-color-failed" :title="scope.row.status_text">In queue</span>
                        <span v-else>{{scope.row.generate_status}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="generate_time"
                    label="Generation Time"
                    align="center"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="produce_time"
                    label="Generation Duration"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.total_time==='0'||scope.row.total_time===0">0s</span>
                        <span v-else-if="!scope.row.total_time">--</span>
                        <span v-else>{{secondToDuration(scope.row.total_time)||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    prop="action"
                    label="Actions"
                    align="center"
                    min-width="150">
                    <template slot-scope="scope">
                        <template v-if="pageFuncNames.includes('daily_task_button')">
                            <!--<span class="text-color-primary pointer mr10" @click="genTask(scope.row)">生成</span>-->
                            <span class="text-color-primary pointer mr10" @click="downloadTask(scope.row)">Download</span>
                        </template>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-bar tac mt20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[30,50,100]"
                :page-size="queryData.rn"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>

        <ErrTipModal ref="errTipModal" />
    </div>
</template>

<script>
    import utils from '@/libs/utils.js';
    import API from '@/api/efficiencyToolEn/task.js';
    import ErrTipModal from '../../modal/errorTipModal';
    export default {
        name: "TaskDetailList",
        props:{
            data:Object,
            pageFuncNames:Array,
        },
        components:{
            ErrTipModal,
        },
        data(){
            return {
                dataLoading:false,
                tempQuery:{
                    template_id:'',
                    account_id:[],
                    subitem_id:[],
                    daily_file_name:'',
                },
                queryData:{
                    task_id:'',
                    template_id:'',
                    account_id:[],
                    subitem_id:[],
                    daily_file_name:'',
                    pn: 1,
                    rn: 30,
                },
                filterAccountOptions: [],
                filterAppOptions: [],
                filterTempOptions:[],
                searchAppLoading:false,
                searchAccountLoading:false,
                dataList:[],
                totalCnt:0,
                refreshTimer:null,
            }
        },
        created(){
            console.log('list detail page created');
            this.startRefresh();
        },
        methods:{
            init(){
                this.getSelectOptions();
                this.submitSearch();
            },
            getSelectOptions(){
                /* 获取模板下拉列表*/
                API.getSearchTemplateList().then(res=>{
                    this.filterTempOptions = res.data||[];
                },err=>{
                    console.log('getGroupOptions',err);
                    this.filterTempOptions = [];
                });
            },
            editTask(){
                console.log('editTask',this.data);
                this.$emit('edit',this.data);
            },
            toListPage(){
                this.$emit('back');
            },
            remoteMethod(query, type) {
                if (!query){
                    if (type == 'creator') {
                        return this.filterAccountOptions = [];
                    } else {
                        return this.filterAppOptions = [];
                    }
                }
                if(type === 'creator'){
                    this.searchAccountLoading = true;
                }else{
                    this.searchAppLoading = true;
                }

                API.getSearchOptions({
                    search_type: type,
                    search: query,
                    task_id:this.data.task_id,
                    source:'task',      // task-任务页面,record-任务记录页面
                }).then(res => {
                    let result = res.data||[];
                    if (type == 'creator') {
                        this.filterAccountOptions = result;
                        this.searchAccountLoading = false;
                    } else {
                        this.filterAppOptions = result;
                        this.searchAppLoading = false;
                    }
                });
            },
            submitSearch(){
                console.log('submitSearch');
                this.queryData.template_id = this.tempQuery.template_id;
                this.queryData.account_id = this.tempQuery.account_id;
                this.queryData.subitem_id = this.tempQuery.subitem_id;
                this.queryData.daily_file_name = this.tempQuery.daily_file_name;
                this.getDataList();
            },
            getDataList(){
                console.log('getDataList');
                this.dataLoading = true;
                API.getTaskDetailList({
                    task_id:this.data.task_id,
                    template_id:this.queryData.template_id,
                    account_id:this.queryData.account_id,
                    subitem_ids:this.queryData.subitem_id,
                    daily_file_name:this.queryData.daily_file_name,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list || []).map(item=>{
                        item.downloadLoading = false;
                        item.genLoading = false;
                        item.statusLoading = false;
                        item.company = item.account_info||[];
                        item.app = item.app_info||[];
                        item.customer = item.customer_info||[];
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getTaskList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            changeTaskStatus(row,val){
                console.log('changeTaskStatus',row,val);
                row.statusLoading = true;
                API.changeTaskDetailStatus({
                    task_detail_id:row.task_detail_id,
                    status:val,
                }).then(res=>{
                    row.statusLoading = false;
                    row.status = val;
                    this.$message.success(res.info||'Operation successful');
                },err=>{
                    row.statusLoading = false;

                    let errData = err.data;

                    if(Array.isArray(errData)){
                        if(err.code==0&&errData.length>0){
                            let errMsg = errData.map((item, index)=>{
                                if(item['errorMsg'].indexOf('The following accounts do not have permission, please contact leader to bind.') != -1) {
                                    return `<p class="font12px">${item.errorMsg}</p>`
                                }else{
                                    return `<p class="font12px">${item.errorMsg}；</p>`
                                }
                            })
                            this.$notify.error({
                                title: err.info||'Request Error',
                                dangerouslyUseHTMLString: true,
                                message: "<div>"+errMsg.join('')+"</div>",
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'Request Error');
                        }
                    }else{
                        if(err.code==403){
                            return this.$message.error(err.info||'Request Error');
                        }
                        let errList = (errData||{}).error_auth||[];
                        this.$refs.errTipModal.showModal({
                            title:err.info||'The following accounts do not have permission and cannot be operated',
                            subTitle:'',
                            actionType:'changeTaskDetailStatus',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }




                })
            },
            resetForm(){
                console.log('resetForm');
                this.tempQuery.template_id = '';
                this.tempQuery.account_id = [];
                this.tempQuery.subitem_id = [];
                this.tempQuery.daily_file_name = '';
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            genTask(row){
                if(row.genLoading) return console.log('loading');
                row.genLoading = true;
                API.genTaskDetail({
                    task_detail_id:row.task_detail_id,
                }).then(res=>{
                    this.$message.success(res.info||'请求成功');
                    row.genLoading = false;
                    this.getDataList();
                },err=>{
                    console.log('genTask err',err);
                    row.genLoading = false;
                    this.$message.error(err.info||'Request Error');
                })
            },
            downloadTask(row){
                console.log('downloadTask',row);
                row.downloadLoading = true;
                let detailId = row.last_detail_record_id;
                API.checkDetailDownload({
                    detail_record_id:detailId,
                    type:'0',
                }).then(res=>{
                    row.downloadLoading = true;
                    let newUrl = '/td/api/daily_task_detail_record/download?detail_record_id='+detailId+'&type=0';
                    console.log('checkDetailDownload',res,newUrl);
                    utils.exportFile(newUrl);
                },err=>{
                    row.downloadLoading = true;
                    console.log('checkDetailDownload err',err);
                    if(err.code==403){
                        return this.$message.error(err.info||'Request Error');
                    }
                    let errData = err.data||{};
                    let errList = errData.error_auth||[];
                    if(errList.length>0){
                        this.$refs.errTipModal.showModal({
                            title:err.info||'The following accounts do not have permission and cannot download',
                            subTitle:'',
                            actionType:'pushTask',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }else{
                        this.$message.error(err.info||'Request Error');
                    }
                });
            },
            startRefresh(){
                if(this.refreshTimer) return;
                this.refreshTimer = setInterval(()=>{
                    let dataList = this.dataList.filter(item=> item.generate_status=='1' || item.generate_status == '3' || item.generate_status == '2' || item.generate_status == '7');
                    if(dataList.length>0) {
                        let IdsArr = dataList.filter(item=>item.last_detail_record_id).map(item=>item.last_detail_record_id);
                        API.getTaskDetialSendStatus({
                            task_detail_record_ids:IdsArr.join(',')
                        }).then(res=>{
                            if(res&&res.code == 200){
                                let resData = res.data ||[];
                                resData.forEach(item=>{
                                    let taskItem = this.dataList.find(task=>task.last_detail_record_id === item.task_detail_record_id );
                                    if(taskItem){
                                        taskItem.generate_status = item.generate_status || taskItem.generate_status;
                                        taskItem.generate_time = item.generate_time || taskItem.generate_time;
                                        taskItem.send_time = item.send_time || taskItem.send_time;
                                        taskItem.send_status = item.send_status || taskItem.send_status;
                                        taskItem.produce_time = item.produce_time || taskItem.produce_time;
                                    }
                                })
                            }
                        })

                    }
                },10*1000)
            },
            stopRefresh(){
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            },
            secondToDuration(val){
                return utils.secondToDuration(val,'en');
            },
        },
        beforeDestroy(){
            console.log('list detail page beforeDestroy');
            this.stopRefresh();
        },
    }
</script>

<style lang="scss" scoped>
    .mini-switch{
        transform: scale(0.8);
    }
</style>
